<template>
  <van-form :readonly="loading" @submit="onSubmit">
    <van-cell-group inset>
      <template v-for="(item, index) in form">
        <template v-if="[1, 2, 3, 4, 5, 6, 8].includes(item.type)">
          <van-field
            :model-value="state.data[item.prop]"
            :key="index"
            :type="textType(item.type)"
            :name="item.prop"
            :label="item.label"
            :placeholder="item.placeholder"
            :required="item.required"
            :rules="getRules(item)"
            @update:model-value="(value) => onInput(item.prop, value)"
          />
        </template>
        <template v-if="item.type === 7">
          <van-field
            :key="index"
            :name="item.prop"
            :label="item.label"
            :required="item.required"
            :rules="getRules(item)"
          >
            <template #input>
              <van-uploader
                v-model="state.data[item.prop]"
                :max-count="1"
              />
            </template>
          </van-field>
        </template>
        <template v-if="item.type === 9">
          <van-field
            :key="index"
            :name="item.prop"
            :label="item.label"
            :required="item.required"
            :rules="getRules(item)"
          >
            <template #input>
              <van-radio-group
                v-model="state.data[item.prop]"
                direction="horizontal"
                class="gusto-radio-group"
              >
                <van-radio
                  v-for="(option, i) in item.placeholder.split(',')"
                  :key="i"
                  :name="option"
                  checked-color="#8CC63F"
                >{{ option }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </template>
      </template>
    </van-cell-group>
    <div style="margin: 32px 16px;">
      <van-button
        :loading="loading"
        loading-text="提交中"
        round
        block
        type="primary"
        native-type="submit"
        color="#8CC63F"
      >提交</van-button>
    </div>
  </van-form>
</template>

<script setup>
import { defineProps, defineEmits, reactive } from 'vue'
import deepcopy from 'deepcopy'

const props = defineProps({
  form: {
    type: Array,
    default: () => []
  },
  data: {
    type: Object,
    default: () => ({})
  },
  loading: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:data', 'submit'])
const state = reactive({
  data: props.data
})

const onInput = (key, value) => {
  const base = deepcopy(state.data)
  const data = {
    ...base,
    [key]: value
  }
  state.data = data
  emit('update:data', data)
}
const textType = (type) => {
  const types = {
    1: 'text',
    2: 'textarea',
    3: 'number',
    4: 'tel'
  }
  return types[type] || 'text'
}
const getRules = (item) => {
  const { minLength, maxLength, required } = item
  // type: 1-文本 2-多行文本 3-数字 4-手机号 5-身份证 6-地址 7-单张图片 8-邮箱
  const res = []
  if (required) {
    // 必填
    res.push({
      required: true,
      message: '此项必填'
    })
  }
  // 是否正确
  switch (item.type) {
    case 4: {
      res.push({
        validator: (val) => {
          const reg = /^(?:(?:\+|00)86)?1\d{10}$/
          if (val && !reg.test(val)) {
            return '请输入正确的手机号'
          }
        }
      })
      break
    }
    case 5: {
      res.push({
        validator: (val) => {
          const reg = /^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/
          if (val && !reg.test(val)) {
            return '请输入正确的身份证号码'
          }
        }
      })
      break
    }
    case 8: {
      res.push({
        validator: (val) => {
          const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (val && !reg.test(val)) {
            return '请输入正确的邮箱'
          }
        }
      })
      break
    }
  }
  // 检测长短
  if (minLength || maxLength) {
    res.push({
      validator: (val) => {
        if (minLength && val.length > 0 && val.length < minLength) {
          return `请最少输入 ${minLength} 个字符`
        }
        if (maxLength && val.length > 0 && val.length > maxLength) {
          return `最多只能输入 ${maxLength} 个字符`
        }
      }
    })
  }
  return res
}
const onSubmit = () => {
  emit('submit')
}

</script>

<style lang="scss">
.van-cell-group {
  margin: 0;
}
.van-cell {
  display: flex;
  flex-direction: column;
  .van-cell__title {
    width: auto;
    margin-right: 0;
  }
  .van-cell__value {
    margin-top: 16px;
  }
}
.gusto-radio-group {
  > .van-radio {
    width: 100%;
    padding-bottom: 8px;
    margin-bottom: 8px;
    .van-radio__icon {
      align-self: flex-start;
      justify-self: flex-start;
    }
  }
}
</style>
